import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './RiskStatusCards.css';

const cx = classnames.bind(styles);

const LEVEL_CARDS = {
    low: { label: 'Unmonitored Low', iconName: 'warningTriangle' },
    moderate: { label: 'Moderate Risk', iconName: 'warningTriangle' },
    high: { label: 'Highly Exposed', iconName: 'warningTriangle' }
};

function RiskStatusCards({ level }) {
    const leftCard = LEVEL_CARDS[level];

    return (
        <div className={styles.root}>
            <div className={cx('card', level)}>
                <Icon name={leftCard.iconName} className={styles.icon} />
                <p className={styles.label}>{leftCard.label}</p>
            </div>
            <div className={cx('card', 'success')}>
                <Icon name='umbrella' className={styles.icon} />
                <p className={styles.label}>Active Monitoring</p>
            </div>
        </div>
    );
}

RiskStatusCards.propTypes = {
    level: PropTypes.oneOf(['low', 'moderate', 'high']).isRequired
};

export {
    RiskStatusCards
};
